<template>
  <el-card style="height: 710px;overflow-y: scroll;">
    <div class="region">
      <p>提示词管理</p>
      <div class="form">
        <el-form inline>
          <el-form-item label="模型关键字">
            <el-input placeholder="请输入" v-model="key" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getRegionData">查看</el-button>
            <el-button @click="searchReset">清空</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="primary" class="add_button" @click="dialogVisible = true">新增提示词</el-button>
      <el-table border :data="tableData" :header-cell-style="{'background-color': '#f6f6f6'}"
                style="width: 100%;margin-top: 20px;">
        <el-table-column align="center" prop="name" label="关键字"></el-table-column>
        <el-table-column align="center" prop="content" label="提示词"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="editRegionShow(scope.row)" type="text" class="button">编辑</el-button>
            <el-button @click="deleteRegion(scope.row.id)" type="text" class="button">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="pageSize"
                     hide-on-single-page @current-change="changePage" @prev-click="changePage"
                     @next-click="changePage" :total="total">
      </el-pagination>

      <el-dialog :modal="false" class="dialog" :visible.sync="dialogVisible" :show-close="false"
                 @close="closeDialog" width="30%">
        <el-form :model="form">
          <el-form-item label="关键字">
            <el-input placeholder="请输入" style="width: 80%" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="提示词">
            <el-input placeholder="请输入" type="textarea" style="width: 80%" v-model="form.content"></el-input>
          </el-form-item>
        </el-form>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import {
  get_model_cue_word,
  create_model_cue_word,
  edit_model_cue_word,
  delete_model_cue_word
} from "@/api/ModelCueWord";

export default {
  name: 'ModelCueWordView',
  data: function () {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      current_page: 1,
      key: '',
      form: {
        name: '',
        content: '',
      },
      dialogVisible: false,
    }
  },
  methods: {
    getRegionData() {
      get_model_cue_word(this.page, this.pageSize, this.key).then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.tableData = data['data']
          this.total = data['count']
        }
      })
    },
    searchReset() {
      this.key = ''
      this.getRegionData()
    },
    closeDialog() {
      this.form = {
        name: '',
        content: '',
      }
      this.dialogVisible = false
    },
    submitRegionForm() {
      let fn
      if (this.form.id) {
        fn = edit_model_cue_word
      } else {
        fn = create_model_cue_word
      }
      fn(this.form.name, this.form.content, this.form.id).then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.$message.success(data['message'])
          this.dialogVisible = false
          this.getRegionData()
        } else {
          this.$message.error(data['error'])
        }
      })
    },
    editRegionShow(row) {
      this.form = row
      this.dialogVisible = true
    },
    deleteRegion(id) {
      delete_model_cue_word(id).then(res => {
        const {data} = res
        if (data['code'] === 200) {
          this.$message.success('删除成功！')
          this.getRegionData()
        }
      })
    },
    changePage(page) {
      this.page = page
      this.getRegionData()
    },
  },
  created() {
    this.getRegionData();
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>